import React from 'react';
import Svg from '../Svg';

const IconAward02 = ({ ...props }) => (
  <Svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 3C8.41015 3 5.5 5.91015 5.5 9.5C5.5 13.0899 8.41015 16 12 16C15.5899 16 18.5 13.0899 18.5 9.5C18.5 5.91015 15.5899 3 12 3ZM3.5 9.5C3.5 4.80558 7.30558 1 12 1C16.6944 1 20.5 4.80558 20.5 9.5C20.5 11.8525 19.5443 13.9818 18 15.5208V22C18 22.3318 17.8354 22.642 17.5606 22.8281C17.2859 23.0141 16.9367 23.0517 16.6286 22.9285L12 21.077L7.37139 22.9285C7.0633 23.0517 6.71414 23.0141 6.43937 22.8281C6.1646 22.642 6 22.3318 6 22V15.5208C4.45569 13.9818 3.5 11.8525 3.5 9.5ZM8 17.0019V20.523L11.3315 19.1904C11.3377 19.1879 11.3449 19.1849 11.353 19.1817C11.4318 19.1495 11.5945 19.0832 11.7726 19.0559C11.9233 19.0327 12.0767 19.0327 12.2274 19.0559C12.4055 19.0832 12.5682 19.1495 12.647 19.1817C12.6551 19.1849 12.6623 19.1879 12.6685 19.1904L16 20.523V17.0019C14.8079 17.6389 13.4461 18 12 18C10.5539 18 9.19215 17.6389 8 17.0019Z"
    />
  </Svg>
);

export default IconAward02;
